import { useState } from 'react'

interface Progress {
  name: string
  progress: number
}
const useProgress = () => {
  const [progress, setProgress] = useState<Progress[]>([])

  const handleProgress = (payload: Progress) => {
    const { name, progress: percent } = payload
    setProgress(prev => {
      if (percent === 100) return [...prev].filter(current => current.name !== name)
      if (prev.some(current => current.name === name)) {
        return [...prev].map(current => (current.name === name ? payload : current))
      } else {
        return [...prev, payload]
      }
    })
  }

  return [progress, handleProgress] as const
}

export { useProgress }
